import React from "react"
import { createContext, useContext, useEffect, useState } from 'react';

const WindowDimensionContext = createContext({ width: 0, height: 0 });
WindowDimensionContext.displayName = 'WindowDimensionContext';

export const WindowDimensionContextProvider = ({children}) => {
    const [viewport, setViewport] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        function handleResize() {
            setViewport({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return(
        <WindowDimensionContext.Provider value={viewport}>
            {children}
        </WindowDimensionContext.Provider>
    )
}

export const useWindowDimensions = () => useContext(WindowDimensionContext);